import store from '../../store';
// 上传凭条接口
const uploadRemitFile = (mobile, code, options) => {
    const fd = new FormData()
    Object.keys(options).map((key) => {
        fd.append(key, options[key])
    })
    store.commit('common/updateSign');
    let appJson = store.getters['common/common'].appJson;
    fd.append('param', JSON.stringify(appJson))
    const env = store.state.env;
    console.log(env);
    const testHost = 'http://puhui-newapp.newapp.test';
    const prodHost = 'https://newapp.iqianzhan.com';
    let host;
    if (env === 'dev' || env === 'test') {
        host = testHost;
    } else if (env === 'production') {
        host = prodHost;
    }
    // http://puhui-newapp.newapp.test/api/v2/case/fileupload/uploadFile/{mobile}/{code}
    return fetch(`${host}/api/v2/case/fileupload/uploadFile/${mobile}/${code}`, {
        method: 'POST',
        body: fd,
        // headers: {
        //   'Content-Type': 'multipart/form-data'
        // }
    }).then(res => {
        if(res.ok) {
            console.log('success')
            return {status: res.status === 200 ? 0 : 1};
        } else {
            console.log('网络错误')
        }
    })
}

export default {
    uploadRemitFile
}